const DataManagementJobType = {

    ExportWithMetadata: 1,
    ExportOnlyFiles: 2,
    Delete: 3,
}
export default DataManagementJobType
